module.exports = __webpack_public_path__ + "img/T2A_rc_20.a01fc9f0.png";